import {
    CATEGORY_ORDER_MAX_LENGTH,
    INDICATOR_COUNTRY_VALUE_TYPE_DECIMAL_MAX_LENGTH,
    INDICATOR_COUNTRY_VALUE_TYPE_TEXT_MAX_LENGTH,
    INDICATOR_ORDER_MAX_LENGTH,
    SUB_CATEGORY_ORDER_MAX_LENGTH
} from './data.config';

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';
export const DEFAULT_SAVE_MESSAGE = 'Your Data has been saved successfully';
export const VIDEO_ALREADY_EXISTS = 'Video already exists';
export const DEFAULT_FAILURE_SAVE_MESSAGE = 'Failed to save data';
export const DELETE_POPUP_TITLE = 'Are you sure you want to delete this item?';
export const DELETE_POPUP_SUMMARY_PART1 = 'Are you sure you want to delete';
export const DELETE_POPUP_SUMMARY_PART2 =
    'This will get deleted permanently. Do you want to proceed?';
export const DELETE_POPUP_SUCCESS = 'Success';
export const DELETE_POPUP_MSG = 'Data deleted successfully';
export const DELETE_POPUP_FAILURE = 'Failed to delete data, please try again';
export const IMAGE_FAILURE_ALT_MSG = 'Unable to load image at this moment, please try again later';

export const SUCCESS_HEADER = 'Success';
export const FAILURE_HEADER = 'Failed';
export const MASTER_DATA_SAVED = 'Your Data has been saved successfully';
export const APPLY_CHANGES_TITLE = 'Are you sure you want to apply the changes?';
export const APPLY_CHANGES =
    'You are going to propagate the changes to GBB Public. Do you want to proceed?';
export const FILE_PROCESSED_SUCCESSFULLY = 'File upload processed successfully';
export const createMessage = (data: any[]) => {
    return `Category ${data.join(
        ' , '
    )} does not contain indicator, add at least one Sub-Category and one indicator before applying changes.`;
};

export const MASTER_DATA_LOAD_SUCCESS = 'Load to Master Data has been initiated successfully';
export const MASTER_DATA_LOAD_FAILED = 'Load to Master Data has failed';
export const MASTER_REVIEW_LOAD_SUCCESS = 'Your Data has been applied successfully';
export const MOVE_SUB_CATEGORY_MODAL_TITLE = 'Move Subcategory';
export const MOVE_SUB_CATEGORY_MODAL_TEXT =
    'Please select a category and subcategory under which the item has to be moved:';
export const MOVED_SUBCATEGORY_SUCCESSFULLY_MESSAGE = 'Sub-Category moved successfully.';
export const MOVED_SUBCATEGORY_SUCCESSFULLY_TITLE = 'Move Sub-Category';

export const MOVED_SUBCATEGORY_WARNING_TITLE = 'Alert';
export const MOVED_SUBCATEGORY_WARNING_MESSAGE = 'Source and target subcategory could not be same!';

export const MOVE_INDICATOR_MODAL_TITLE = 'Move Indicator';
export const MOVE_INDICATOR_MODAL_TEXT =
    'Please select a category and subcategory under which the item has to be moved:';
export const MOVED_INDICATOR_SUCCESSFULLY_MESSAGE = 'Indicator moved successfully.';
export const MOVED_INDICATOR_SUCCESSFULLY_TITLE = 'Move Indicator';

export const LINK_MODAL_TITLE = 'Link Indicator';
export const LINK_MODAL_TEXT =
    'Please select a subcategory under which these indicators to be linked:';

export const LINK_CONFIRMATION_MODAL_TITLE = 'Link Indicator Confirmation';
export const LINK_CONFIRMATION_MODAL_TEXT =
    'You are trying to link an existing indicator to a new Sub-category. Are you sure you want to apply changes';

export const MAP_TO_VARIANT_SUCCESS_MESSAGE =
    'The data you have selected has been mapped successfully to ';
export const MAP_TO_VARIANT_SUCCESS_MESSAGE_TITLE = 'Variant and data mapped successfully';

export const MAP_TO_VARIANT_NO_ITEM_ERROR_MESSAGE =
    'Please choose items from tree view to map against the varient!';
export const MAP_TO_VARIANT_NO_ITEM_ERROR_MESSAGE_TITLE = 'Warning';

export const MAP_TO_VARIANT_ERROR_MESSAGE = 'Data and variant has not been selected!';
export const MAP_TO_VARIANT_ERROR_MESSAGE_TITLE = 'Please choose variant';
export const MAP_TO_VARIANT_NEST_OR_INDICATOR =
    'Please map the dataset with parent Category and then indicators without parent (sub-category) separately.';
export const MAP_TO_VARIANT_NEST_OR_INDICATOR_TITLE = 'Message';
export const MAP_TO_VARIANT_SELECT_CAT_SUBCAT_TITLE = 'You are about to map indicators to: ';
export const MAP_TO_VARIANT_SELECT_CAT_SUBCAT_MESSAGE =
    'Please select a category & subcategory under which these indicators to mapped under ';

export const MOVE_VALIDATION_ERROR_MESSAGE =
    'Please select category or subcategory to move or choose radio button to create new!';

export const ARCHIVE_CONFIRMATION_TITLE = 'Are you sure that you want this item to be archived?';
export const ARCHIVE_CONFIRMATION_SUMMARY_1 = 'You are going to archive';
export const ARCHIVE_CONFIRMATION_SUMMARY_2 = `It will be available in “Archived Items” page (after "Apply changes"). Will be auto deleted after one year.`;

export const DELETE_KEY_INDICATOR_CONFIRMATION = `Do you want to remove this record from key indicator?`;
export const DELETE_STATIC_INDICATOR_CONFIRMATION = `Do you want to remove this record from static indicator?`;

export const RESTORE_SUCCESS = 'Data restored successfully!';
export const RESTORE_CONFIRMATION_TITLE = 'Are you sure that you want this item to be restored?';
export const RESTORE_CONFIRMATION_TEXT_MASTER =
    'Items restored will be restored back to Master data and to all variants';
export const RESTORE_CONFIRMATION_TEXT_VARIANT = 'Items restored will be added to ';
export const RESTORE_MODAL_TITLE = 'You are about to restore item to ';
export const RESTORE_MODAL_TEXT =
    'Please select Category/Sub-Category under which Sub-Category/Indicator is to be restored';
export const RESTORE_INDICATOR_TO_CATEGORY_ERROR =
    'You can add indicator at Sub-Category level only!';
export const CATEGORY_DESCRIPTION_MAX_LENGTH_ERROR = 'Description exceeds 1000 characters!';
export const CATEGORY_DESCRIPTION_INVALID_CHAR_ERROR = 'Description has invalid characters';

export const NAME_INVALID_CHAR_ERROR = 'Name has invalid characters';
export const NAME_EMPTY_ERROR = 'Name cannot be empty';
export const NO_VIDEO_ERROR = 'Please upload video';
export const NO_IMAGE_ERROR = 'Please upload image';
export const ARTICLE_EMPTY_ERROR = 'Please add article link';
export const APPLICATION_EMPTY_ERROR = 'Please add application link';
export const NAME_MAX_LENGTH_ERROR = 'Name exceeds 75 characters!';
export const INVALID_URL = 'Data is invalid, please provide valid URL';

export const DESCRIPTION_MAX_LENGTH_ERROR = 'Description exceeds 200 characters!';
export const DESCRIPTION_INVALID_CHAR_ERROR = 'Description has invalid characters';
export const CATEGORY_NAME_MAX_LENGTH_ERROR = 'Category Name exceeds 200 characters!';
export const CATEGORY_NAME_INVALID_CHAR_ERROR = 'Category Name has invalid characters';
export const CATEGORY_NAME_EMPTY_ERROR = 'Category Name cannot be empty';
export const CATEGORY_ORDER_EMPTY_ERROR = 'Category Order cannot be empty';
export const CATEGORY_ORDER_INVALID_ERROR = 'Invalid Category order';
export const CATEGORY_ORDER_GREATER_THAN_ZERO = 'Category order should be greater than 0';
export const CATEGORY_ORDER_MAX_LENGTH_ERROR =
    'Category order should not be greater than ' + CATEGORY_ORDER_MAX_LENGTH + '!';

export const CATEGORY_EDIT_SUCCESS = 'Category has been updated successfully';
export const CATEGORY_EDIT_FAIL = 'Category edit has failed';
export const CATEGORY_NAME_DUPLICATE_ERROR =
    'Please change the name of the category to create a clone with its meta data.';

export const CATEGORY_ADD_SUCCESS = 'Category has been added successfully';
export const CATEGORY_ADD_FAIL = 'Category add has failed';
export const SUB_CATEGORY_DESCRIPTION_MAX_LENGTH_ERROR = 'Description exceeds 1000 characters!';
export const SUB_CATEGORY_DESCRIPTION_INVALID_CHAR_ERROR = 'Description has invalid characters';
export const SUB_CATEGORY_NAME_MAX_LENGTH_ERROR = 'Sub category Name exceeds 200 characters!';
export const SUB_CATEGORY_NAME_INVALID_CHAR_ERROR = 'Sub category has invalid characters.';
export const SUB_CATEGORY_NAME_EMPTY_ERROR = 'Sub category Name cannot be empty';
export const SUB_CATEGORY_ORDER_EMPTY_ERROR = 'Sub category Order cannot be empty';
export const SUB_CATEGORY_EDIT_SUCCESS = 'Sub category has been updated successfully';
export const SUB_CATEGORY_ADD_SUCCESS = 'Sub category has been added successfully';
export const SUB_CATEGORY_EDIT_FAIL = 'Sub category edit has failed';
export const SUB_CATEGORY_ADD_FAIL = 'Sub category add has failed';
export const SUB_CATEGORY_ORDER_INVALID_ERROR = 'Invalid sub category order';
export const SUB_CATEGORY_ORDER_GREATER_THAN_ZERO = 'Sub category order should be greater than 0';
export const SUB_CATEGORY_NAME_DUPLICATE_ERROR =
    'Please change the name of the sub category to create new indicator based on its meta data.';
export const INDICATOR_DESCRIPTION_MAX_LENGTH_ERROR = 'Description exceeds 1000 characters!';
export const INDICATOR_DESCRIPTION_INVALID_CHAR_ERROR = 'Description has invalid characters';
export const INDICATOR_NAME_MAX_LENGTH_ERROR = 'Indicator Name exceeds 200 characters!';
export const INDICATOR_NAME_INVALID_CHAR_ERROR = 'Indicator has invalid characters.';
export const INDICATOR_NAME_REQUIRED = 'Indicator name cannot be empty.';
export const INDICATOR_NAME_EMPTY_ERROR = 'Indicator Name cannot be empty';
export const INDICATOR_NAME_DUPLICATE_ERROR =
    'Please change the name of the indicator to create new indicator based on its meta data.';
export const INDICATOR_ORDER_EMPTY_ERROR = 'Indicator Order cannot be empty';
export const INDICATOR_SOURCE_REQUIRED = 'Indicator Source cannot be empty.';
export const INDICATOR_UPDATE_FREQUENCY_REQUIRED = 'Indicator Update Frequency cannot be empty.';
export const INDICATOR_SOURCE_MAX_LENGTH_ERROR = 'Indicator Source exceeds 75 characters!';
export const INDICATOR_REFERENCE_MAX_LENGTH_ERROR = 'Indicator Reference exceeds 2500 characters!';
export const INDICATOR_WEB_ADDRESS_REQUIRED = 'Indicator Web address cannot be empty.';

export const SUB_CATEGORY_ORDER_MAX_LENGTH_ERROR =
    'Sub category order should not be greater than ' + SUB_CATEGORY_ORDER_MAX_LENGTH + '!';

export const INDICATOR_ORDER_MAX_LENGTH_ERROR =
    'Indicator Order should not be greater than ' + INDICATOR_ORDER_MAX_LENGTH + '!';

export const INDICATOR_YEAR_FORMAT_ERROR = 'Indicator Year format is incorrect';
export const INDICATOR_SOURCE_DATE_FORMAT_ERROR = 'Indicator Source Date format is incorrect';
export const INDICATOR_SOURCE_DATE_ERROR = 'Indicator Source Date cannot be empty';
export const INDICATOR_EDIT_SUCCESS = 'Indicator has been updated successfully';
export const INDICATOR_EDIT_FAIL = 'Indicator edit has failed';
export const INDICATOR_VALUE_TYPE_OVERRIDE = 'Are you sure you want to override?';
export const INDICATOR_COUNTRY_VALUE_TYPE_DECIMAL_ERROR = 'Only 2 decimal places are allowed.';
export const INDICATOR_COUNTRY_VALUE_TYPE_INTEGER_ERROR = 'Only integer value allowed.';

export const INDICATOR_COUNTRY_VALUE_TYPE_DECIMAL_MAX_LENGTH_ERROR =
    'Country value type should not be greater than ' +
    INDICATOR_COUNTRY_VALUE_TYPE_DECIMAL_MAX_LENGTH +
    '!';

export const INDICATOR_COUNTRY_VALUE_TYPE_TEXT_MAX_LENGTH_ERROR =
    'Country value type should not be exceed ' +
    INDICATOR_COUNTRY_VALUE_TYPE_TEXT_MAX_LENGTH +
    ' character!';

export const EDIT_SUCCESS_MESSAGE = 'Data updated successfully';
export const INDICATOR_ADD_SUCCESS = 'Indicator has been added successfully';
export const INDICATOR_ADD_FAIL = 'Indicator add has failed';
export const INDICATOR_LINK_SUCCESS = 'Indicator linked to new sub-category successfully';
export const INDICATOR_ORDER_INVALID_ERROR = 'Invalid indicator order';
export const INDICATOR_ORDER_REQUIRED = 'Indicator order cannot be empty';
export const INDICATOR_ORDER_GREATER_THAN_ZERO = 'Indicator order should be greater than 0';

export const INDICATOR_SEARCH_COUNTRIES = 'Search countries';

export const ERROR_FIX_PENDING_MESSAGE = `Below listed is a preview of the data uploaded, please click on <mark>'Edit'</mark> icon to fix the errors. Once all the errors are fixed, click on <mark>'Load to Master Data'</mark>. You will be able to map the data once this is done!`;
export const ERROR_FIX_COMPLETED_MESSAGE = `All the errors are fixed, click on <mark>'Load to Master Data'</mark>. You will be able to map the data to variants from Master data.`;

export const COPY_CONFIRMATION_TITLE = 'Are you sure you want this item to be copied?';
export const COPY_CONFIRMATION_DESCRIPTION =
    'You are copying an indicator and creating as new indicator under different sub category. Are you sure you want to apply changes?';
export const INDICATOR_COPY_SUCCESS = 'Indicator Copied successfully';
export const INDICATOR_COPY_FAIL = 'Indicator Copy Failed';

export const CLONE_CONFIRMATION_TITLE = 'Are you sure you want this item to be cloned?';
export const CLONE_CONFIRMATION_DESCRIPTION =
    'You are creating a Clone (duplicate) of data. Are you sure you want to apply changes?';
export const CLONE_SUCCESS = 'Data clone created successfully';
export const CLONE_FAILED = 'Clone has failed';

export const MOVE_INDICATOR_TO_ANOTHER_SUBCATEGORY_TITLE = 'Move indicator';
export const MOVE_INDICATOR_TO_ANOTHER_SUBCATEGORY_DESCRIPTION =
    'You are moving an indicator from one sub category to another sub category. Are you sure you want to apply changes?';
export const MOVE_SUBCATEGORY_TO_ANOTHER_SUBCATEGORY_TITLE = 'Move Subcategory';
export const MOVE_SUBCATEGORY_TO_ANOTHER_SUBCATEGORY_DESCRIPTION =
    'You are moving a subcategory from one sub category to another sub category. Are you sure you want to apply changes?';
export const MASTER_DATA_NOTIFICATION_BANNER_MESSAGE =
    'Below listed is the master data. You can map, edit, move & archive them based on the requirement.';

export const ARCHIVE_VALIDATION_FAILED = 'Archive validation failed';
export const ARCHIVE_FAILED = 'Archive failed';
export const ARCHIVE_SUCCESS = 'Entity archived successfully.';

export const KEY_INDICATOR_GUIDE = `Below are the listed items you have selected for 'Key indicators'. To remove click on <mark>'delete'</mark> icon. To add, click on <mark>'Add new'</mark>. You can add maximum 10 <mark>Key Indicator</mark> items. 
Here you can make changes to the configuration, to propagate your changes to external Application, click on <mark>'Map to GBB Public'</mark>.`;
export const TRENDING_DATA_GUIDE = `Below are the listed items you have selected for 'Trending data'. To remove click on <mark>'delete'</mark> icon. To add, click on <mark>'Add new'</mark>. You can add maximum 10 <mark>Trending data</mark> items. 
Here you can make changes to the configuration, to propagate your changes to external Application, click on <mark>'Map to GBB Public'</mark>.`;
export const STATIC_INDICATOR_GUIDE = `Below are the listed items you have selected for 'Static indicators'. To remove click on <mark>'delete'</mark> icon. To add, click on <mark>'Add new'</mark>. You can add maximum 10 <mark>Static Indicator</mark> items. 
Here you can make changes to the configuration, to propagate your changes to external Application, click on <mark>'Map to GBB Public'</mark>.`;
export const WHATS_NEW_GUIDE = `Below listed are the items you have created to show in the <mark>‘What’s New’</mark> section of the website. You can add maximum 10 <mark>What's New</mark> items. 
Here you can make changes to the configuration, to propagate your changes to external Application, click on <mark>'Map to GBB Public'</mark>.`;
export const FREQUENTLY_USED_GUIDE = `Below listed are the items you have selected for 'Frequently Used'. To remove, click on <mark>'delete'</mark> icon. To add, click on <mark>'Add new'</mark>. You can add maximum 10 <mark>Frequently used</mark> items. 
Here you can make changes to the configuration, to propagate your changes to external Application, click on <mark>'Map to GBB Public'</mark>.`;
export const GEOGRAPHY_OVERVIEW_GUIDE = `Below listed are the items you have selected for 'Geography Indicators'. To remove, click on <mark>'delete'</mark> icon. To add, click on <mark>'Add new'</mark>. You can add maximum 10 <mark>Geography Indicators</mark> items.
Here you can make changes to the configuration, to propagate your changes to external Application, click on <mark>'Map to GBB Public'</mark>.`;
export const VIDEO_LINK_GUIDE = `Below listed are the Video Links used in external Application. To remove, click on <mark>'delete'</mark> and to add click on <mark>'Add new'</mark>.
Here you can make changes to the configuration, to propagate your changes to external Application, click on <mark>'Map to GBB Public'</mark>.`;

export const LINKED_INDICATOR_EDIT_TOOLTIP =
    'Edit is not allowed on Child Indicator. Please try it on Parent Indicator!';
export const DELETE_DISABLED = 'Selected item is under review mode, please save before Deleting';
export const ARCHIVE_DISABLED = 'Selected item is under review mode, please save before Archiving';
export const CLONE_DISABLED = 'Selected item is under review mode, please save before Cloning';

export const ADD_DISABLED_IN_REVIEW_TOOLTIP =
    'Upload is not allowed on "Under Review" entities. Please apply changes and try to upload again!';
export const ARCHIVE_DELETE_DISABLED =
    'There are pending changes to be synced on Master Data. Please "Apply changes" on Master Data and try again!';

export const CORE_FILE_UPLOAD_TITLE = 'Upload core data file';
export const CONCURRENT_UPLOAD_TITLE = 'Upload process is locked by another user:';
export const UPLOADED_ON_TITLE = 'Uploaded on';

export const AUTH_ERROR_INVALID_TOKEN = 'Authentication failed: Invalid Token';
export const RENEW_SESSION_TITLE = 'Renew Session';
export const RENEW_SESSION_DESCRIPTION =
    'Your session has expired. Please Renew Session to continue.';

export const DISCARD_CHANGES_TITLE = 'Are you sure you want to discard the changes?';
export const DISCARD_CHANGES_DESCRIPTION =
    'By discarding changes, you will lose ALL THE NEW CHANGES IN MASTER DATA (Review Mode) made by you and others as well! Are you sure you want to discard changes?';
export const DISCARD_CHANGES_SUCCESS = 'All changes made after the last sync cleared successfully';

export const CLEAR_PREVIEW_CONF_TITLE = 'Are you sure you want to clear preview?';
export const CLEAR_PREVIEW_CONF_MESSAGE =
    'By clearing preview, you will lose the uploaded data and you need to re-upload again. Are you sure you want to discard changes?';
export const CLEAR_PREVIEW_SUCCESS = 'Preview has been cleared successfully';

export const MAP_TO_PUBLIC_SUCCESS =
    'Job has started. Please check Sync history queue to monitor the update.';

export const INDICATOR_SOURCE_ADD_FAIL = 'Indicator source addition has failed';
export const INDICATOR_SOURCE_ADD_SUCCESS = 'Indicator source has been added successfully';
export const INDICATOR_SOURCE_EDIT_FAIL = 'Indicator source edit has failed';
export const INDICATOR_SOURCE_EDIT_SUCCESS = 'Indicator source has been edited successfully';
export const INDICATOR_SOURCE_DELETE_FAIL = 'Indicator source delete has failed';
export const INDICATOR_SOURCE_DELETE_SUCCESS = 'Indicator source has been deleted successfully';

export const COMPANY_INFO_EDIT_FAIL = 'Failed to update company info';
export const COMPANY_INFO_EDIT_SUCCESS = 'Company Info has been edited successfully';
export const COMPANY_FOOTPRINT_UPDATE_FAIL = 'Failed to update company footprint';
export const COMPANY_FOOTPRINT_UPDATE_SUCCESS = 'Company footprint has been edited successfully';
export const COPY_VALIDATION_TITLE = 'Copy Indicator';
export const COPY_VALIDATION_ERROR_MESSAGE =
    'Please select category or subcategory to copy or choose radio button to create new!';

export const MOVE_FAILED = 'Move has failed';
export const EXPORT_POPUP_TITLE = 'Are you sure you want to export this?';
export const EXPORT_POPUP_ERROR_MESSAGE = 'Export has failed. Please check';
export const EXPORT_SUCCESS = 'Data exported successfully.';
export const EXPORT_POPUP_MESSAGE =
    'This operation will export the Master Data. Do you want to proceed?';

export const ROLE_CREATE_SUCCESS = 'Role has been created successfully';
export const ROLE_CREATE_FAILED = 'Role creation failed';
export const ROLE_DELETE_SUCCESS = 'Role has been deleted successfully';
export const ROLE_DELETE_FAILED_WHEN_USERS_MAPPED =
    'Users are mapped to the role, please remove the users from the role to delete it.';
export const ROLE_DELETE_FAILED = 'Role delete has failed';
export const ROLE_EDIT_SUCCESS =
    'Role details has been updated successfully.Please refresh the Application to see the changes.';
export const ROLE_EDIT_FAIL = 'Role details edit has failed';
export const DUPLICATE_ROLENAME = 'Role name already exists';
export const CLONE_SUB_CATEGORY_TITLE = 'Clone a sub-category';
export const CLONE_VALIDATION_ERROR_MESSAGE =
    'Please select category or subcategory to clone or choose radio button to create new!';
